import React from 'react';
import axios from "../../../../containers/api";
import {Button, CardBody, Row, CardTitle} from "reactstrap";
import {Colxx, Separator} from "../../../../components/common/CustomBootstrap";
import {Table} from "../../../../components/table/Table";
import {showCatchError} from "../../../../helpers/Utils";

class ShowTransportationCompanyUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            OneTransportationCompany: this.props.OneTransportationCompany,
            TransportationCompanies: this.props.TransportationCompanies,
            TransportationCompanyUsers: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({
                OneTransportationCompany: this.props.OneTransportationCompany,
                TransportationCompanies: this.props.TransportationCompanies
            });
        }
    }

    componentDidMount() {
        this.GetByUserId();
    }

    GetByUserId = () => {
        this.props.showSpinner();
        axios.get('/api/v1/transportation-company-users/GetByUserId?Id=' + this.state.OneTransportationCompany.userId)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ TransportationCompanyUsers: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
            });
    };

    DeleteTransportationCompanyUser = (Id) => {
        this.props.showSpinner();
        let model = {
            Item1: Id
        };
        axios.post('/api/v1/transportation-company-users/DeleteTransportationCompanyUser', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.GetByUserId()
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    AddTransportationCompanyUser = (TransportationCompanyId) => {
        let model = {
            TransportationCompanyId: TransportationCompanyId,
            UserAdminId: this.state.OneTransportationCompany.userId
        }

        this.props.showSpinner();
        axios.post('/api/v1/transportation-company-users/AddTransportationCompanyUser', model)
            .then((res) => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.GetByUserId();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody>
                        <CardTitle>
                            لیست نمایندگی‌های
                            {" "}
                            {this.state.OneTransportationCompany && this.state.OneTransportationCompany.fullName}
                        </CardTitle>

                        <Table
                            tableHeaders={[
                                "شناسه",
                                "نام کامل",
                                "کد ملی",
                                "موبایل",
                                "حذف",
                            ]}

                            tableRow={this.state.TransportationCompanyUsers !== null ? this.state.TransportationCompanyUsers : []}

                            tableData={[
                                TransportationCompany => {
                                    return "TC" + TransportationCompany.transportationCompanyNationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyName;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyNationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyMobile;
                                },
                                TransportationCompany => {
                                    return (
                                        <Button outline color="danger" size="sm"
                                            onClick={() => this.DeleteTransportationCompanyUser(TransportationCompany.id)}>
                                            حذف
                                        </Button>
                                    )
                                }
                            ]}
                        />

                        <Separator className="my-5" />

                        <CardTitle>لیست کل نمایندگی‌ها</CardTitle>

                        <Table
                            tableHeaders={[
                                "شناسه",
                                "نام کامل",
                                "کد ملی",
                                "موبایل",
                                "افزودن",
                            ]}

                            tableRow={this.state.TransportationCompanies !== null ? this.state.TransportationCompanies : []}

                            tableData={[
                                TransportationCompany => {
                                    return "TC" + TransportationCompany.nationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.transportationCompanyName;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.nationalId;
                                },
                                TransportationCompany => {
                                    return TransportationCompany.mobile;
                                },
                                TransportationCompany => {
                                    return (
                                        <Button outline color="success" size="sm"
                                            onClick={() => this.AddTransportationCompanyUser(TransportationCompany.transportationCompanyId)}>
                                            افزودن
                                        </Button>
                                    )
                                }
                            ]}
                        />
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default ShowTransportationCompanyUser;